<div class="project-selector-modal">
    <ui-field iconName="search" [label]="'BUTTONS.SEARCH' | translate">
        <input #searchField advizeoInput [ngModel]="search$ | async" [clearable]="true" (ngModelChange)="search$.next($event)" />
    </ui-field>
    <div class="project-list">
        <div class="grid-container grid-1" advizeoBooleanControlGroup [(ngModel)]="selectedProjectId">
            @for (project of projects$ | async; track project) {
                <ui-radio-button controlValueAccessorInterop [label]="project.name" [advizeoBooleanControlValue]="project.projectId" />
            }
        </div>
    </div>
</div>
